module.exports = __webpack_public_path__ + "static/media/vegan-gluten-free-chocolate-chunk.2fd69239.png";